import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0553b6d0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0553b6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553b6d0",
  null
  
)

export default component.exports